// extracted by mini-css-extract-plugin
export default {"section":"second_section__Jq+QB","second":"second_second__K04q2"};